/**
 * 用社区框架打开页面
 * 适用于随手记
 */
define('util/client-requestBBS',[
  'util/client-bridge',
  'util/host'
], function(clientBridge, host) {
  return function(url) {
    var _url = host(url);
    if (CLIENT_DATA.client === 'ssj') {
      clientBridge.call(clientBridge.uriSuishouji('requestBBS', {
        url: _url
      }));
    } else {
      window.location.href = url
    }
  };
});

